import { OnInit } from "@angular/core";
import { Field } from '../models/field.model';
export class FormDualListBoxComponent extends Field {
    constructor() {
        super(...arguments);
        /**
         * Attributes
         */
        this.OBJ_dual_list_config = {
            key: 'id',
            display: 'title',
            order: 'order',
            orderDrag: true,
            filter: true,
            sort: true,
            sortAttr: '_order',
            type: 'sample2',
            format: {
                direction: 'left-to-right',
                draggable: true,
                translate: {
                    buttons: {
                        assign: 'oDualListbox.sAssign',
                        assign_all: 'oDualListbox.sAssignAll',
                        remove: 'oDualListbox.sRemove',
                        remove_all: 'oDualListbox.sRemoveAll'
                    },
                    search: {
                        available: 'oDualListbox.sFilterAvailable',
                        confirmed: 'oDualListbox.sFilterConfirmed'
                    },
                    order: 'oDualListbox.sOrder'
                }
            }
        };
    }
    /**
     * Function > ngOnInit
     * @return {any}
     */
    ngOnInit() { } // end function ngOnInit
    /**
     * Function > selected
     * @param {object} ARR_values
     */
    selected(ARR_values) {
        this.markAsDirtyAndTouched();
    } // end function selected
} // end class FormDualListBoxComponent
